"use strict";

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _unmutable = _interopRequireDefault(require("./internal/unmutable"));

var _pipeWith = _interopRequireDefault(require("./util/pipeWith"));

var _entryArray = _interopRequireDefault(require("./entryArray"));

var _default = (0, _unmutable["default"])({
  name: 'reduce',
  immutable: 'reduce',
  array: function array(reducer) {
    for (var _len = arguments.length, initialReduction = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      initialReduction[_key - 1] = arguments[_key];
    }

    return function (value) {
      return initialReduction.length ? value.reduce(reducer, initialReduction[0]) : value.reduce(reducer);
    };
  },
  all: function all(reducer) {
    for (var _len2 = arguments.length, initialReduction = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      initialReduction[_key2 - 1] = arguments[_key2];
    }

    return function (value) {
      var fn = function fn(reduction, _ref) {
        var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
            key = _ref2[0],
            childValue = _ref2[1];

        return reducer(reduction, childValue, key, value);
      };

      return (0, _pipeWith["default"])(value, (0, _entryArray["default"])(), function (entries) {
        if (initialReduction.length) {
          return entries.reduce(fn, initialReduction[0]);
        }

        return entries.length ? entries.slice(1).reduce(fn, entries[0][1]) : undefined;
      });
    };
  }
});

exports["default"] = _default;